import { BookOpenIcon, DotsVerticalIcon, LinkIcon, TrashIcon } from "@heroicons/react/outline";
import { useState } from "react";

import PlaygroundTourFirstVisit from "../Playground/tour/PlaygroundTourFirstVisit";
import PlaygroundTourTrigger from "../Playground/tour/PlaygroundTourTrigger";

import RelatedContentDialog from "./RelatedContentDialog";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuBasicTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

interface PromptTemplateActionsMenuProps {
  canShowDeploymentGuide: boolean;
  canShowRelatedContent: boolean;
  deleteDisabled: boolean;
  deleteTooltip?: string;
  onDelete: () => void;
  onOpenDeploymentGuide: () => void;
}

const PromptTemplateActionsMenu = ({
  canShowDeploymentGuide,
  canShowRelatedContent,
  deleteDisabled,
  deleteTooltip,
  onDelete,
  onOpenDeploymentGuide,
}: PromptTemplateActionsMenuProps) => {
  const [isRelatedContentOpen, setRelatedContentOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuBasicTrigger asChild>
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0 hover:bg-gray-100">
            <DotsVerticalIcon className="h-5 w-5 text-gray-500" />
            <span className="sr-only">More prompt actions</span>
          </Button>
        </DropdownMenuBasicTrigger>
        <DropdownMenuContent align="end" className="w-60">
          {canShowDeploymentGuide && (
            <DropdownMenuItem onSelect={onOpenDeploymentGuide} className="!w-full gap-2">
              <BookOpenIcon className="mr-2 h-4 w-4" />
              Deployment guide
            </DropdownMenuItem>
          )}

          {canShowRelatedContent && (
            <DropdownMenuItem
              onSelect={() => setRelatedContentOpen(true)}
              className="!w-full gap-2"
            >
              <LinkIcon className="mr-2 h-4 w-4" />
              Datasets & evaluations
            </DropdownMenuItem>
          )}

          <div className="px-1 py-1">
            <PlaygroundTourFirstVisit>
              <PlaygroundTourTrigger
                size="sm"
                className="flex h-8 w-full items-center justify-start gap-2 rounded-sm px-2 text-sm font-normal text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              />
            </PlaygroundTourFirstVisit>
          </div>

          <DropdownMenuSeparator />

          <DropdownMenuItem
            onSelect={onDelete}
            disabled={deleteDisabled}
            title={deleteTooltip}
            className="!w-full gap-2 text-red-600 focus:!bg-red-50 focus:!text-red-700"
          >
            <TrashIcon className="mr-2 h-4 w-4" />
            Delete prompt
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {canShowRelatedContent && (
        <RelatedContentDialog open={isRelatedContentOpen} onOpenChange={setRelatedContentOpen} />
      )}
    </>
  );
};

export default PromptTemplateActionsMenu;
